import styled from 'styled-components';

import theme from '@adsk/alloy-react-theme';

export const bodyStyle = {
  padding: '23px 17px',
  scrollbarGutter: 'stable both-edges',
};

export const subscriptionsContainer = {
  margin: '0 86px',
};

export const ErrorLabel = styled.div`
  color: ${theme.colors.charcoal500};
  ${theme.typography.heading2}
`;

export const loadingSpinnerContainerStyles = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  marginTop: 130,
};
